import { useQuery } from '@tanstack/react-query';

import { agent } from 'api/agent';

export const fileKey = ['feasibilityReport'];

const useFileFeasibilityReport = () => useQuery({
  queryKey: fileKey,
  queryFn: () => agent.getClient()('file-data/calc?dataType=feasibility_report').then((response) => response?.data as string[]),
});

export default useFileFeasibilityReport;
